import { apiClient } from '../../utilities/apiClient';

// POST /auth/phone/inbound/request — body is empty, anon JWT identifies
// the caller. Returns { nonce, helplineNumber }.
export const requestInboundCode = async () => {
  const res = await apiClient.post('/auth/phone/inbound/request');
  return res.data;
};

// GET /auth/phone/status?nonce=X — returns { status: 'pending' } until the
// admin verifies. On verified the response sets new cookies server-side
// and returns { status: 'verified', user }.
export const pollInboundStatus = async ({ nonce }) => {
  const res = await apiClient.get('/auth/phone/inbound/status', {
    params: { nonce },
  });
  return res.data;
};

// GET /auth/phone/inbound/info — { helplineNumber, verifiedCount }. Cached
// in the SPA so the AuthWizard + Settings can share without re-fetching.
let infoCache = null;
export const fetchInboundInfo = async ({ force = false } = {}) => {
  if (infoCache && !force) return infoCache;
  const res = await apiClient.get('/auth/phone/inbound/info');
  infoCache = res.data;
  return infoCache;
};
